import React from 'react';

const STATUS = {
  idle:       { label: 'Idle',       color: 'var(--gray-500)', bg: 'var(--gray-100)', dot: 'var(--gray-400)' },
  recording:  { label: 'Recording',  color: 'var(--red)',       bg: 'var(--red-light)', dot: 'var(--red)' },
  processing: { label: 'Processing', color: 'var(--orange)',    bg: 'var(--orange-light)', dot: 'var(--orange)' },
  completed:  { label: 'Ready',      color: 'var(--green)',     bg: 'var(--green-light)', dot: 'var(--green)' },
};

export default function CourtStatusCard({ court }) {
  const cfg = STATUS[court.status] || STATUS.idle;
  const session = court.active_session;
  const fmt = s => { if (!s) return '0:00'; const m = Math.floor(s/60), sec = s%60; return `${m}:${String(sec).padStart(2,'0')}`; };

  return (
    <div style={s.card}>
      <div style={s.top}>
        <div>
          <div style={s.courtNum}>Court {court.court_number}</div>
          <div style={s.courtName}>{court.court_name}</div>
        </div>
        <span style={{ ...s.badge, background: cfg.bg, color: cfg.color }}>
          {court.status === 'recording' && <span style={{ ...s.dot, background: cfg.dot }} />}
          {cfg.label}
        </span>
      </div>

      {session ? (
        <div style={s.session}>
          <div style={s.playerName}>{session.player_email}</div>
          <div style={s.elapsed}>{fmt(session.duration_seconds)}</div>
        </div>
      ) : (
        <div style={s.idle}>No active session</div>
      )}
    </div>
  );
}

const s = {
  card: {
    background: 'var(--white)', borderRadius: 'var(--radius)',
    padding: '18px 20px', boxShadow: 'var(--shadow-sm)',
    border: '1px solid var(--gray-200)',
  },
  top: {
    display: 'flex', justifyContent: 'space-between',
    alignItems: 'flex-start', marginBottom: 14,
  },
  courtNum: { fontSize: 12, color: 'var(--gray-400)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 2 },
  courtName: { fontSize: 15, fontWeight: 700, color: 'var(--gray-900)' },
  badge: {
    fontSize: 12, fontWeight: 600, padding: '4px 10px',
    borderRadius: 50, display: 'flex', alignItems: 'center', gap: 5,
    whiteSpace: 'nowrap',
  },
  dot: {
    width: 6, height: 6, borderRadius: '50%',
    display: 'inline-block',
    animation: 'pulse-dot 1.2s ease-in-out infinite',
  },
  session: {},
  playerName: { fontSize: 15, fontWeight: 600, color: 'var(--gray-900)', marginBottom: 4 },
  elapsed: { fontSize: 28, fontWeight: 300, color: 'var(--gray-700)', fontVariantNumeric: 'tabular-nums' },
  idle: { fontSize: 14, color: 'var(--gray-400)', fontStyle: 'italic' },
};
